// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"551":"c3423c21","842":"b80ccfe5"}[chunkId] + ".chunk.js";
};